/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  GetQueryParams,
  ListQueriesParams,
  QueryCreateRequest,
  QueryCreateResponse,
  QueryGetResponse,
  QueryListResponse,
  QueryUpdateRequest,
  QueryUpdateResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useCreateQueryHook = () => {
        const createQuery = useCustomInstance<QueryCreateResponse>();

        return useCallback((
    queryCreateRequest: QueryCreateRequest,
 signal?: AbortSignal
) => {
        return createQuery(
          {url: `/Query/Create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: queryCreateRequest, signal
    },
          );
        }, [createQuery])
      }
    


export const useCreateQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateQueryHook>>>, TError,{data: QueryCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateQueryHook>>>, TError,{data: QueryCreateRequest}, TContext> => {

const mutationKey = ['createQuery'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createQuery =  useCreateQueryHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateQueryHook>>>, {data: QueryCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createQuery(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateQueryMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateQueryHook>>>>
    export type CreateQueryMutationBody = QueryCreateRequest
    export type CreateQueryMutationError = unknown

    export const useCreateQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateQueryHook>>>, TError,{data: QueryCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateQueryHook>>>,
        TError,
        {data: QueryCreateRequest},
        TContext
      > => {

      const mutationOptions = useCreateQueryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useListQueriesHook = () => {
        const listQueries = useCustomInstance<QueryListResponse>();

        return useCallback((
    params?: ListQueriesParams,
 signal?: AbortSignal
) => {
        return listQueries(
          {url: `/Query/List`, method: 'GET',
        params, signal
    },
          );
        }, [listQueries])
      }
    

export const getListQueriesQueryKey = (params?: ListQueriesParams,) => {
    return [`/Query/List`, ...(params ? [params]: [])] as const;
    }

    
export const useListQueriesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError = unknown>(params?: ListQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQueriesQueryKey(params);

  const listQueries =  useListQueriesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>> = ({ signal }) => listQueries(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQueriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>>
export type ListQueriesQueryError = unknown


export function useListQueries<TData = Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError = unknown>(
 params: undefined |  ListQueriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQueries<TData = Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError = unknown>(
 params?: ListQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQueries<TData = Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError = unknown>(
 params?: ListQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListQueries<TData = Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError = unknown>(
 params?: ListQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQueriesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useGetQueryHook = () => {
        const getQuery = useCustomInstance<QueryGetResponse>();

        return useCallback((
    params?: GetQueryParams,
 signal?: AbortSignal
) => {
        return getQuery(
          {url: `/Query/Get`, method: 'GET',
        params, signal
    },
          );
        }, [getQuery])
      }
    

export const getGetQueryQueryKey = (params?: GetQueryParams,) => {
    return [`/Query/Get`, ...(params ? [params]: [])] as const;
    }

    
export const useGetQueryQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError = unknown>(params?: GetQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQueryQueryKey(params);

  const getQuery =  useGetQueryHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>> = ({ signal }) => getQuery(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQueryQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>>
export type GetQueryQueryError = unknown


export function useGetQuery<TData = Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError = unknown>(
 params: undefined |  GetQueryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuery<TData = Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError = unknown>(
 params?: GetQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuery<TData = Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError = unknown>(
 params?: GetQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuery<TData = Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError = unknown>(
 params?: GetQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQueryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQueryQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useUpdateQueryHook = () => {
        const updateQuery = useCustomInstance<QueryUpdateResponse>();

        return useCallback((
    queryUpdateRequest: QueryUpdateRequest,
 ) => {
        return updateQuery(
          {url: `/Query/Update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: queryUpdateRequest
    },
          );
        }, [updateQuery])
      }
    


export const useUpdateQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateQueryHook>>>, TError,{data: QueryUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateQueryHook>>>, TError,{data: QueryUpdateRequest}, TContext> => {

const mutationKey = ['updateQuery'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateQuery =  useUpdateQueryHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateQueryHook>>>, {data: QueryUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateQuery(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateQueryMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateQueryHook>>>>
    export type UpdateQueryMutationBody = QueryUpdateRequest
    export type UpdateQueryMutationError = unknown

    export const useUpdateQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateQueryHook>>>, TError,{data: QueryUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateQueryHook>>>,
        TError,
        {data: QueryUpdateRequest},
        TContext
      > => {

      const mutationOptions = useUpdateQueryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    